/**
 * @generated SignedSource<<5115b6b9751976da4cccebdfa11e899a>>
 * @relayHash 8ad65162c5f1035a73a944370d0dd21e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9313d5b0b508312695bd1da49a9804f5f985a5b7cc9e0be91babddaf00daae4c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

import withInlineCreateMigration_provider from '@atlassian/jira-relay-provider/src/ibs-44-board-inline-create-migration.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "9313d5b0b508312695bd1da49a9804f5f985a5b7cc9e0be91babddaf00daae4c",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcibs44boardinlinecreatemigrationrelayprovider": withInlineCreateMigration_provider
    }
  }
};

export default node;
